import Hero from "@/components/site/Hero";
import AuctionSection from "@/components/site/AuctionSection";
import Packages from "@/components/site/Packages";
import WhyToriano from "@/components/site/WhyToriano";
import LeaderOfThePack from "@/components/site/LeaderOfThePack";
import Testimonials from "@/components/site/Testimonials";
import Faq from "@/components/site/Faq";
import DogTrainingAuthority from "@/components/site/DogTrainingAuthority";
import Method from "@/components/site/Method";
import Credibility from "@/components/site/Credibility";
import Pathways from "@/components/site/Pathways";
import AssessmentBanner from "@/components/site/AssessmentBanner";
import Marquee from "@/components/site/Marquee";
import LiveAuctionPill from "@/components/site/LiveAuctionPill";
import { useEffect } from "react";

export default function HomePage() {
  useEffect(() => {
    document.title = "Toriano Sanzone — Master Dog Trainer, Founder, Strategist";
  }, []);
  return (
    <>
      <Hero />
      <AuctionSection />
      <Packages />
      <WhyToriano />
      <LeaderOfThePack />
      <Testimonials />
      <Marquee />
      <DogTrainingAuthority />
      <Method />
      <AssessmentBanner />
      <Credibility />
      <Pathways />
      <Faq />
      <LiveAuctionPill />
    </>
  );
}
